import React from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const formatTime = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
};

/**
 * Scrollable list of chat messages with customer/admin bubbles.
 */
const MessageList = ({ messages, userInfo, messagesEndRef }) => {
  if (messages.length === 0) {
    return (
      <div className="flex-1 overflow-y-auto p-4 space-y-3">
        <div className="text-center text-gray-500 py-8">
          <p>Hi {userInfo.name}!</p>
          <p className="text-sm">Send us a message and we'll get back to you shortly.</p>
        </div>
        <div ref={messagesEndRef} />
      </div>
    );
  }

  return (
    <div className="flex-1 overflow-y-auto p-4 space-y-3">
      {messages.map((msg, idx) => (
        <div
          key={msg._id || `msg-${idx}`}
          className={`flex ${msg.sender_type === 'customer' ? 'justify-end' : 'justify-start'}`}
        >
          <div
            className={`max-w-[80%] rounded-2xl px-4 py-2 ${
              msg.sender_type === 'customer'
                ? 'bg-green-600 text-white rounded-br-md'
                : 'bg-gray-100 text-gray-800 rounded-bl-md'
            }`}
          >
            {msg.sender_type === 'admin' && msg.sender_name && (
              <p className="text-xs font-semibold text-green-700 mb-0.5">{msg.sender_name}</p>
            )}
            <p className="text-sm">{msg.content}</p>
            {msg.file_url && (
              <a
                href={`${BACKEND_URL}${msg.file_url}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-xs underline mt-1 block"
              >
                View Attachment
              </a>
            )}
            <p className={`text-xs mt-1 ${msg.sender_type === 'customer' ? 'text-green-100' : 'text-gray-400'}`}>
              {formatTime(msg.created_at)}
            </p>
          </div>
        </div>
      ))}
      <div ref={messagesEndRef} />
    </div>
  );
};

export default MessageList;
